import { useEffect, useState } from "react";
import { Users, Wallet2, Clock, FolderOpen } from "lucide-react";
import { api } from "@/lib/api";
import { money } from "@/lib/format";
import { Loading, PageTitle, Stat } from "@/components/Common";
import { EmpleadosPanel } from "@/components/nomina/EmpleadosPanel";
import { PeriodosPanel } from "@/components/nomina/PeriodosPanel";
import { PonchesPanel } from "@/components/nomina/PonchesPanel";

const PESTANAS = [
  { v: "empleados", label: "Empleados", icon: Users },
  { v: "periodos", label: "Nóminas", icon: Wallet2 },
  { v: "ponches", label: "Ponches", icon: Clock },
];

export default function AdminNomina() {
  const [datos, setDatos] = useState(null);
  const [candidatos, setCandidatos] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [pestana, setPestana] = useState("empleados");

  const cargar = () => {
    api.get("/nomina/empleados", { params: { incluir_inactivos: true } })
      .then((r) => setDatos(r.data)).catch(() => setDatos({ empleados: [], resumen: {} }));
    api.get("/nomina/candidatos").then((r) => setCandidatos(r.data)).catch(() => setCandidatos([]));
    api.get("/nomina/periodos").then((r) => setPeriodos(r.data)).catch(() => setPeriodos([]));
  };

  useEffect(cargar, []);

  if (!datos) return <Loading />;
  const r = datos.resumen || {};
  const activos = datos.empleados.filter((e) => e.activo !== false);

  return (
    <div data-testid="admin-nomina">
      <PageTitle title="Nómina del personal"
                 subtitle="Empleados y expedientes, ponches de entrada y salida, y nómina con AFP (2.87%), SFS (3.04%) e ISR según la escala de la DGII." />

      <div className="mb-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Empleados activos" value={r.empleados || 0} icon={Users} testId="nomina-empleados" />
        <Stat label="Nómina mensual" value={money(r.nomina_mensual)} icon={Wallet2}
              testId="nomina-mensual" />
        <Stat label="Por horas" value={r.por_horas || 0} icon={Clock} testId="nomina-por-horas" />
        <Stat label="Sin expediente" value={r.sin_expediente || 0} icon={FolderOpen}
              tone={r.sin_expediente ? "warn" : "default"} testId="nomina-sin-expediente" />
      </div>

      <div className="mb-6 flex flex-wrap gap-2 border-b border-border pb-3">
        {PESTANAS.map((p) => (
          <button key={p.v} onClick={() => setPestana(p.v)} data-testid={`pestana-${p.v}`}
                  className={`rounded-full px-5 py-2 text-sm lift ${
                    pestana === p.v ? "bg-primary font-semibold text-primary-foreground"
                                    : "text-muted-foreground hover:bg-muted"}`}>
            <p.icon className="mr-2 inline h-4 w-4" /> {p.label}
          </button>
        ))}
      </div>

      {pestana === "empleados" && (
        <EmpleadosPanel empleados={datos.empleados} candidatos={candidatos} onListo={cargar} />
      )}
      {pestana === "periodos" && <PeriodosPanel periodos={periodos} onListo={cargar} />}
      {pestana === "ponches" && <PonchesPanel empleados={activos} />}
    </div>
  );
}
